import { Button } from 'components/Button';
import { ICONS } from 'components/Icon';
import { useSelector } from 'hooks/useSelector';
import { theme } from 'lib/theme';
import React from 'react';
import { useDispatch } from 'react-redux';
import { REMOTE_ACCOUNT_LOAD_TFA } from 'store/actions';
import {
  selectUserTfaEnabled,
  selectUserTfaRequired,
} from 'store/auth/selectors';

export const TfaRequiredIndicator: React.FC = () => {
  const dispatch = useDispatch();
  const isTfaRequired = useSelector(selectUserTfaRequired);
  const isTfaEnabled = useSelector(selectUserTfaEnabled);

  if (!isTfaRequired || isTfaEnabled) {
    return null;
  }

  return (
    <Button
      text="MFA"
      icon={ICONS.InputNumberDuo}
      destructive
      onPress={() => dispatch(REMOTE_ACCOUNT_LOAD_TFA())}
      style={{ marginTop: 8, marginLeft: theme.paddingHorizontal / 2 }}
    />
  );
};
